import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-738f0750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-[60px] pb-[60px] box-sizing w-[100%] common-swiper newsconn-info" }
const _hoisted_2 = { class: "flex relative bg-white w-[1080px]" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "w-[504px]" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-[14px] leading-[14px] text-[#999] inline-block border-b-[2px] border-[#666] pb-[5px]" }
const _hoisted_7 = { class: "desc indent-[2em]" }

import { ref, toRefs, useAttrs, watch, nextTick } from "vue";
import {
  Autoplay,
  Pagination,
  Navigation,
  Scrollbar,
  EffectFade,
} from "swiper";
import { Swiper } from "swiper/vue";
import "swiper/css/pagination"; // 轮播图底面的小圆点
import "swiper/css/navigation"; // 轮播图两边的左右箭头
import "swiper/css/effect-fade"; // 淡入淡出
// 在modules加入要使用的模块

export default /*#__PURE__*/_defineComponent({
  __name: 'CommonSwiper',
  emits: ['toDetail'],
  setup(__props, { emit: __emit }) {

const navigation = ref({
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
});
const modules = [Autoplay, Pagination, Navigation, Scrollbar, EffectFade];
const emit = __emit
const { swiperList } = toRefs(useAttrs()) as any;
const swiperInstance = ref<
  (InstanceType<typeof Swiper> & { slideTo: (index: number) => void }) | null
>(null);
function onSwiper(swiper) {
  swiperInstance.value = swiper;
}

function onSlideChange(swiper) {
  console.log(swiper);
}

function toDetail(item) {
  emit('toDetail',item)
}

return (_ctx: any,_cache: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      modules: modules,
      "slides-per-view": 1,
      autoplay: { delay: 5000 },
      loop: true,
      style: {"height":"340px"},
      navigation: navigation.value,
      pagination: { clickable: true },
      scrollbar: { draggable: false },
      class: "swiperBox",
      effect: "fade",
      fadeEffect: { crossFade: true },
      onSwiper: onSwiper,
      onSlideChange: onSlideChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(swiperList) || [], (item) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: item.id,
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: item.banner,
                  class: "w-[540px] h-[280px] mr-[36px] object-cover"
                }, null, 8, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h3", {
                    class: "text-[18px] text-[#333] leading-[20px] mb-[20px] hover:text-[var(--el-color-primary)]",
                    onClick: ($event: any) => (toDetail(item))
                  }, _toDisplayString(item.title), 9, _hoisted_5),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(item.createTime), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(item.digest), 1)
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["navigation"])
  ]))
}
}

})